import { AdminComponent } from '~/components/admin-component/admin-component';

export const Ridings = () => (
  <AdminComponent
    componentName="Ridings"
    title="Ridings"
  />
);
